<script lang="ts">
  import UnityText from '$components/unity-text.svelte';
  import LL from '$i18n/i18n-svelte';
  import { idToItem } from './stores';
  import { getItemSkillName, getItemSkillDescription } from './translation';

  export let id: number;
  $: item = $idToItem.get(id)!;
</script>

{#each item.skills as skill}
  <section>
    <h3><UnityText taggedText={getItemSkillName($LL, skill.id)} /></h3>
    <p><UnityText taggedText={getItemSkillDescription($LL, skill.id)} /></p>
  </section>
{/each}

<style lang="postcss">
  section {
    display: flex;
    flex-direction: column;
    background-color: var(--elevation-1);
    gap: var(--space-2);
    padding: var(--space-3);
    border-radius: var(--radius-1);
  }
</style>
